import { FormInput } from "common/components/form/hookForms/FormInput";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getLandPlotNumberInfo } from "../../../api/geocode.api";
import { FormInputSuggestion } from "../../../components/form/FormInputSuggestion";

interface PostalCodeFieldProps {}

export const PostalCodeField = ({}: PostalCodeFieldProps) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();

  const cityId = watch("cityId");
  const streetId = watch("streetId");
  const streetNumber = watch("streetNumber");
  const postalCode = watch("postalCode");
  const address = watch("address");

  const { data } = useQuery(
    ["land_plot_number", cityId, streetId, streetNumber],
    () => getLandPlotNumberInfo(cityId, streetId, streetNumber),
    {
      enabled: !!cityId && !!streetId && !!streetNumber,
      staleTime: Infinity,
      keepPreviousData: true,
    }
  );

  return (
    <>
      <FormInput
        label={t("propertyForm.postalCodeLabel")}
        name="postalCode"
        variant="text"
      />
      <FormInputSuggestion
        currentValue={postalCode}
        suggestionLabel={data?.PASTO_KODAS ?? ""}
        suggestedValue={data?.PASTO_KODAS}
        onAgree={(value) => {
          setValue("postalCode", value);
        }}
        source="RC"
        address={address}
      />
    </>
  );
};
